module.exports = __webpack_public_path__ + "images/g-yuryev-f78017.jpg";